import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { PageHero } from "../components/ui-parts";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const loc = useLocation();
  const { user } = useAuth();

  // "next" tells us where to send the user after successful sign-in.
  // Defaults to home. Set by the caller via location.state or ?next=/path.
  const search = new URLSearchParams(loc.search);
  const next = loc.state?.next || search.get("next") || "/";

  useEffect(() => {
    if (user) nav(next, { replace: true });
  }, [user, next, nav]);

  const signIn = () => {
    // Remember where to go after auth (used by AuthCallback)
    try { sessionStorage.setItem("js_post_login_redirect", next); } catch {}
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + next;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page">
      <PageHero badge="Sign In" title="Sign in to Jayatu Sanskrutam" subtitle="Sign in with your Google account to track your enrolments, volunteer with us, and manage your profile." />
      <section className="section">
        <div className="container-narrow max-w-md">
          <div className="js-card p-8 text-center">
            <ShieldCheck size={40} className="mx-auto text-[var(--js-primary)]" />
            <h3 className="font-heading text-xl mt-4">Continue with Google</h3>
            <p className="text-sm text-[var(--js-muted)] mt-2">We use your Google account only to recognise you. We never ask for a password and we never post anything on your behalf.</p>
            <button onClick={signIn} className="js-btn-primary mt-6 w-full justify-center" data-testid="google-signin-btn">
              <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.3l-6.3-5.2C29.2 35 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.4 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.3 5.2c-.4.4 6.7-4.9 6.7-14.9 0-1.2-.1-2.3-.4-3.5z"/></svg>
              Sign in with Google
            </button>
            <p className="text-xs text-[var(--js-muted)] mt-4">By signing in you agree to our community guidelines.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
